import { render } from "./Register_3.vue?vue&type=template&id=c3a302ae&scoped=true"
import script from "./Register_3.vue?vue&type=script&lang=js"
export * from "./Register_3.vue?vue&type=script&lang=js"

import "./Register_3.vue?vue&type=style&index=0&id=c3a302ae&scoped=true&lang=css"

import exportComponent from "C:\\Users\\noklo\\Documents\\GitHub\\Rayong\\Rayong-query-community\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3a302ae"]])

export default __exports__